class TopMessage {
    constructor() {
        this.enable = true;
        this.bodyClass = 'has-top-message';
        this.currentMessageKey = 'wefunder_campaign';
        this.localStorageCurrentMessageKey = `top_message_${this.currentMessageKey}`;
        this.bodyElement = $('body');
    }

    mounted() {
        this.checkItShouldBeEnabled();

        if (this.enable) {
            // Mark the body with a specific class so specific CSS style can adjust their display (padding-top...)
            if (!this.bodyElement.hasClass(this.bodyClass)) {
                this.bodyElement.addClass(this.bodyClass);
            }
        }

        // Register event
        $('.top-message .close-button').click(() => {
            this.close();
        });
    }

    close() {
        this.enable = false;

        if (this.bodyElement) {
            this.bodyElement.removeClass(this.bodyClass);
        }

        localStorage.setItem(this.localStorageCurrentMessageKey, 'disabled');
    }

    checkItShouldBeEnabled() {
        const item = localStorage.getItem(this.localStorageCurrentMessageKey);
        if (item !== null && item === 'disabled') {
            this.enable = false;
        }
    }
}

$(document).ready(function () {
    var topMessage = new TopMessage();
    topMessage.mounted();
});
